import React, { Children } from 'react';
import Grid from '@mui/material/Grid2';
import PropTypes from 'prop-types';

export default function PersonalInfoGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[0]}</Grid>
        <Grid size={6}>{items[1]}</Grid>
      </Grid>
      <Grid size={4}>{items[2]}</Grid>
      <Grid container size={8}>
        <Grid size={12}>{items[3]}</Grid>
        <Grid size={12}>{items[4]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[5]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[6]}</Grid>
        <Grid size={6}>{items[7]}</Grid>
      </Grid>
      <Grid container size={12} spacing={3}>
        <Grid size={6}>{items[8]}</Grid>
        <Grid size={6}>{items[9]}</Grid>
      </Grid>
      <Grid size={12}>{items[10]}</Grid>
      <Grid size={12}>{items[11]}</Grid>
      <Grid size={12}>{items[12]}</Grid>
    </Grid>
  );
}

PersonalInfoGrid.propTypes = {
  children: PropTypes.node,
};
